import { create } from 'zustand';
import { m } from '../utils/dateUtils';
const INITIAL_STATE = {

    restoring: false,

    selectedDayFlag: null,

    selectedPastDate: null,

    selectedVehicle: '',

    vehicleChangeMotive: 0,

    timeBefore: 0,

    inicioManual: null,

    fimManual: null,

    openConflictModal: false

};

export const useCalendarModalStore = create((set, get) => ({

    ...INITIAL_STATE,

    setSelectedDayFlag: (selectedDayFlag) => {

        set(state => {

            if (state.selectedDayFlag === selectedDayFlag) {
                return state;
            }

            return { selectedDayFlag };

        });

    },

    setSelectedPastDate: (selectedPastDate) => {

        set(state => {

            if (state.selectedPastDate === selectedPastDate) {
                return state;
            }

            return { selectedPastDate };

        });

    },

    setSelectedVehicle: (selectedVehicle) => {

        set(state => {

            if (state.selectedVehicle === selectedVehicle) {
                return state;
            }

            return { selectedVehicle };

        });

    },

    setVehicleChangeMotive: (vehicleChangeMotive) => {

        set(state => {

            if (state.vehicleChangeMotive === vehicleChangeMotive) {
                return state;
            }

            return { vehicleChangeMotive };

        });

    },

    setTimeBefore: (timeBefore) => {

        set(state => {

            if (state.timeBefore === timeBefore) {
                return state;
            }

            return { timeBefore };

        });

    },

    setInicioManual: (inicioManual) => {

        set(state => {

            if (state.inicioManual === inicioManual) {
                return state;
            }

            return { inicioManual };

        });

    },

    setFimManual: (fimManual) => {

        set(state => {

            if (state.fimManual === fimManual) {
                return state;
            }

            return { fimManual };

        });

    },

    setOpenConflictModal: (openConflictModal) => {

        set(state => {

            if (state.openConflictModal === openConflictModal) {
                return state;
            }

            return { openConflictModal };

        });

    },

    clear: () => {

        set(state => {

            if (
                state.restoring === INITIAL_STATE.restoring &
                state.selectedDayFlag === INITIAL_STATE.selectedDayFlag &&
                state.selectedPastDate === INITIAL_STATE.selectedPastDate &&
                state.selectedVehicle === INITIAL_STATE.selectedVehicle &&
                state.vehicleChangeMotive === INITIAL_STATE.vehicleChangeMotive &&
                state.timeBefore === INITIAL_STATE.timeBefore &&
                state.inicioManual === INITIAL_STATE.inicioManual &&
                state.fimManual === INITIAL_STATE.fimManual &&
                state.openConflictModal === INITIAL_STATE.openConflictModal
            ) {
                return state;
            }

            return {
                ...INITIAL_STATE
            };

        });

    },

    setRestoring: (restoring) => set({ restoring }),

    exportState: () => {

        const {
            selectedDayFlag,
            selectedPastDate,
            selectedVehicle,
            vehicleChangeMotive,
            timeBefore,
            inicioManual,
            fimManual
        } = get();

        return {
            selectedDayFlag,
            selectedPastDate,
            selectedVehicle,
            vehicleChangeMotive,
            timeBefore,
            inicioManual: inicioManual?.format('YYYY-MM-DD HH:mm:ss') ?? null,
            fimManual: fimManual?.format('YYYY-MM-DD HH:mm:ss') ?? null,
            openConflictModal: false
        };

    },

    importState: (state) => {

        if (!state) {
            return;
        }

        set({
            ...state,
            inicioManual: state.inicioManual ? m(state.inicioManual) : null,
            fimManual: state.fimManual ? m(state.fimManual) : null,
            restoring: true
        });

    },

}));